import React, { PureComponent } from 'react';

import { bool, func, object } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Box } from '@mui/material';

import { Button } from '../Button';
import styles from './styles.module.scss';

class LoadableSplashScreen extends PureComponent {
  static propTypes = {
    error: object,
    intl: intlShape.isRequired,
    pastDelay: bool,
    retry: func,
  };

  static defaultProps = {
    error: null,
    pastDelay: false,
  };

  onRetryClick = () => {
    const { retry } = this.props;

    if (retry) {
      retry();
    } else {
      window.location.reload();
    }
  };

  render() {
    const { error, intl, pastDelay } = this.props;
    const containerSx = {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    };

    if (error) {
      return (
        <Box className={styles.container} sx={containerSx}>
          {intl.formatMessage({ id: 'labels.error' })}
          <div>
            <Button
              size="large"
              variant="outlined"
              color="primary"
              sx={{ border: 0 }}
              labelId="labels.retry"
              onClick={this.onRetryClick}
            />
          </div>
        </Box>
      );
    } else if (pastDelay) {
      return (
        <Box className={styles.container} sx={containerSx}>
          {intl.formatMessage({ id: 'labels.loading' })}
        </Box>
      );
    }

    return null;
  }
}

export default injectIntl(LoadableSplashScreen);
